// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--EGkYO","comment":"da51a739f7--comment--omrrj","type":"da51a739f7--type--tOhTz","button":"da51a739f7--button--BKul1"};